module.exports = __webpack_public_path__ + "static/media/settings.b0775cf0.svg";